import {
  ADD_FAVOURITE_PRODUCT,
  ADD_FAVOURITE_PRODUCT_SUCCESS,
  FETCH_PRODUCT_LOOKUP_DATA,
  FETCH_PRODUCT,
  FETCH_PRODUCT_SUCCESS,
  FETCH_ALL_PRODUCT,
  FETCH_ALL_PRODUCT_SUCCESS,
  FILTER_PRODUCT,
  GET_ALL_PRODUCT,
  GET_UNSELECTED_ALL_PRODUCT,
  HANDLE_PRODUCT_REQUEST_CLOSE,
  HIDE_PRODUCT_LOADER,
  SHOW_PRODUCT_LOADER,
  ON_ADD_PRODUCT,
  ON_EDIT_PRODUCT,
  SET_PRODUCT,
  ON_ALL_PRODUCT_SELECT,
  ON_PRODUCT_CLOSE,
  ON_PRODUCT_SELECT,
  ON_DELETE_PRODUCT,
  ON_DELETE_PRODUCT_SUCCESS,
  ON_FILTER_SELECTED_PRODUCT,
  ON_FILTER_PRODUCT_OPTION_SELECT,
  ON_SAVE_PRODUCT,
  ON_SAVE_PRODUCT_SUCCESS,
  ON_TOGGLE_PRODUCT_DRAWER,
  SHOW_PRODUCT_MESSAGE,
  UPDATE_SEARCH_PRODUCT,
  ON_FETCH_SELECT_VALUESTREAM_DATA,
  ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS,
  ON_PRODUCT_VALUESTREAM_UPDATE,
} from 'constants/ActionTypes';

export const fetchProductLookupData = () => {
  return {
    type: FETCH_PRODUCT_LOOKUP_DATA,
  };
};
export const onProductValueStreamUpdate = () => {
  return {
    type: ON_PRODUCT_VALUESTREAM_UPDATE,
  };
};
export const onFetchSelectValueStreamData = () => {
  return {
    type: ON_FETCH_SELECT_VALUESTREAM_DATA,
  };
};
export const onFetchSelectValueStreamDataSuccess = (payload) => {
  return {
    type: ON_FETCH_SELECT_VALUESTREAM_DATA_SUCCESS,
    payload
  };
};
export const setProduct = (payload) => {
  return {
    type: SET_PRODUCT,
    payload
  };
};
export const fetchProduct = (payload) => {
  return {
    type: FETCH_PRODUCT,
    payload
  };
};
export const fetchProductSuccess = (payload) => {
  return {
    type: FETCH_PRODUCT_SUCCESS,
    payload
  };
};
export const fetchProducts = () => {
  return {
    type: FETCH_ALL_PRODUCT
  };
};
export const fetchProductsSuccess = (payload) => {
  return {
    type: FETCH_ALL_PRODUCT_SUCCESS,
    payload
  };
};
export const showProductMessage = (message) => {
  return {
    type: SHOW_PRODUCT_MESSAGE,
    payload: message
  };
};
export const addFavouriteProduct = (payload) => {
  return {
    type: ADD_FAVOURITE_PRODUCT,
    payload
  };
};
export const addFavouriteProductSuccess = (payload) => {
  return {
    type: ADD_FAVOURITE_PRODUCT_SUCCESS,
    payload
  };
};
export const onProductSelect = (payload) => {
  return {
    type: ON_PRODUCT_SELECT,
    payload
  };
};
export const onAddProduct = () => {
  return {
    type: ON_ADD_PRODUCT,
  };
};
export const onEditProduct = (payload) => {
  return {
    type: ON_EDIT_PRODUCT,
    payload
  };
};
export const onProductClose = () => {
  return {
    type: ON_PRODUCT_CLOSE,
  };
};
export const onFilterProductOptionSelect = (payload) => {
  return {
    type: ON_FILTER_PRODUCT_OPTION_SELECT,
    payload
  };
};
export const onSaveProduct = (payload) => {
  return {
    type: ON_SAVE_PRODUCT,
    payload
  };
};
export const onSaveProductSuccess = (data) => {
  return {
    type: ON_SAVE_PRODUCT_SUCCESS,
    payload: data
  };
};
export const onDeleteProduct = (payload) => {
  return {
    type: ON_DELETE_PRODUCT,
    payload
  };
};
export const onDeleteProductSuccess = (payload) => {
  return {
    type: ON_DELETE_PRODUCT_SUCCESS,
    payload
  };
};
export const onFilterSelectedProduct = () => {
  return {
    type: ON_FILTER_SELECTED_PRODUCT,
    payload: ''
  };
};
export const filterProduct = (payload) => {
  return {
    type: FILTER_PRODUCT,
    payload
  };
};
export const getAllProduct = () => {
  return {
    type: GET_ALL_PRODUCT,
    payload: ''
  };
};
export const getUnselectedAllProduct = () => {
  return {
    type: GET_UNSELECTED_ALL_PRODUCT,
    payload: ''
  };
};
export const onAllProductSelect = () => {
  return {
    type: ON_ALL_PRODUCT_SELECT,
    payload: ''
  };
};
export const updateSearchProduct = (payload) => {
  return {
    type: UPDATE_SEARCH_PRODUCT,
    payload
  };
};
export const onToggleProductDrawer = () => {
  return {
    type: ON_TOGGLE_PRODUCT_DRAWER,
  };
};
export const handleProductRequestClose = () => {
  return {
    type: HANDLE_PRODUCT_REQUEST_CLOSE,
  };
};
export const showProductLoader = () => {
  return {
    type: SHOW_PRODUCT_LOADER,
  };
};
export const hideProductLoader = () => {
  return {
    type: HIDE_PRODUCT_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/product.js